import React from "react";
import styled from "styled-components";
import { Icon } from "react-icons-kit";
import {ButtonIconContainer} from "../ButtonIconContainer";


const ButtonContainer = styled.div`
  text-align: center;
  margin-left: 10px;
  margin-right: 10px;
  margin-bottom: 15px;
  // width: 100px;
`;

const ButtonText = styled.div`
  margin-top: 15px;
  & > a {
    font-weight: 100;
    color: ${(props) => props.fontColor ? props.fontColor : 'white'};
    text-decoration-line: none;
  }
`;

const Button = styled.button`
  background-color: ${(props) => (props.color ? props.color : "DodgerBlue")};
  border: none;
  outline: none;
  height: 50px;
  width: 50px;
  border-radius: 50%;
  margin: 10;
  box-shadow: 0px 0px 8px 0px #a9a9a9;
  transition: transform 0.7s;
  &:active {
    border: none;
  }
  @media (hover:hover) and (pointer:fine){
    &:hover {
      transform: scale(1.3);
    }
  }
`;

export default function RoundButton({ text, icon, link , color , fontColor , onClick}) {

  // const isLinkButton = (onClick === null || onClick === undefined) ? true : false;
  const shouldDisplayText =(text !== null && text !== undefined);

  return (
    <ButtonContainer onClick={onClick ? () => onClick() : null }>
        {
          // isLinkButton ?
          <a href={link}>
            <Button color={color} >
              {icon ? (
                <ButtonIconContainer color={fontColor}>
                  <Icon size={25} icon={icon} />
                </ButtonIconContainer>
              ) : null}
            </Button>
          </a>
          // :
          // <Button color={color} onClick={onClick ? onClick : null }>
          //   {icon ? (
          //     <ButtonIconContainer color={fontColor}>
          //       <Icon size={25} icon={icon} />
          //     </ButtonIconContainer>
          //   ) : null}
          // </Button>
        }
      {
        shouldDisplayText ?
        <ButtonText fontColor={fontColor}>
          {
            // isLinkButton ?
            <a href={link}>{text}</a>
            // :
            // text
          }
        </ButtonText>
        :
        null
      }
    </ButtonContainer>
  );
}
